import React from 'react';
import Dropdown, { Option } from '@app/react-common/components/dropdown/Dropdown';
import Button from '@app/react-common/components/button/Button';
import { AbTestTypeCategory, AbTestWidgetTypeLabels } from '../../../models/AbTestCreationType';
import { getTitle } from './abTestModalUtils';
import useAbTestTypeOptions from '../../list-ab-tests/hooks/useAbTestTypeOptions';

const TYPE_PICKER_MENU_WIDTH = 220;

interface AbTestModalHeaderProps {
  mode: 'create' | 'edit' | 'view' | 'duplicate';
  testTypeCategory: AbTestTypeCategory;
  onClose: () => void;
  onTestTypeChange?: (testType: AbTestTypeCategory) => void;
  isTestTypeLocked?: boolean;
}

export function AbTestModalHeader({
  mode,
  testTypeCategory,
  onClose,
  onTestTypeChange,
  isTestTypeLocked = false,
}: AbTestModalHeaderProps) {
  const showTypePicker = mode === 'create' && !!onTestTypeChange;
  const abTestTypeOptions = useAbTestTypeOptions();

  return (
    <div className="ab-test-modal__header">
      <h2 className="ab-test-modal__title">{showTypePicker ? 'Create A/B Test' : getTitle(mode, testTypeCategory)}</h2>
      <div className="ab-test-modal__header-actions">
        {showTypePicker &&
          (isTestTypeLocked ? (
            <span className="ab-test-modal__test-type-tag">{AbTestWidgetTypeLabels[testTypeCategory]}</span>
          ) : (
            <Dropdown
              variant="light"
              options={abTestTypeOptions}
              width={TYPE_PICKER_MENU_WIDTH}
              preSelectedOption={{ label: AbTestWidgetTypeLabels[testTypeCategory], value: testTypeCategory }}
              onSelect={(option: Option | null) => {
                if (option && option.value !== testTypeCategory) {
                  onTestTypeChange(option.value as AbTestTypeCategory);
                }
              }}
            />
          ))}
        <Button icon="close" variant="ghost" size="small" onClick={onClose} />
      </div>
    </div>
  );
}
